"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPositionSelected = void 0;
const isPositionSelected = (position) => {
    const anyGeometryPoints = Boolean(position.geometryPoints?.[0]?.length);
    return Boolean(position) && (position.position || position.geometry || anyGeometryPoints);
};
exports.isPositionSelected = isPositionSelected;
